module.exports = __webpack_public_path__ + "static/media/29ADMSPC33.4da43cf1.jpg";